import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=0a6a7d74&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "../../less/gift.less?vue&type=style&index=0&id=0a6a7d74&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a7d74",
  null
  
)

export default component.exports